export default {
  import: {
    fields: {
      name: 'ขำเข้า',
      import_status: {
        success: 'นำเข้าสำเร็จ',
      },
    },
  },
}
